/* eslint-disable */
export default {
  onSearching: 'Chargement…',
  noContacts: 'Aucun enregistrement trouvé.',
} as const;

// @key: @#@"onSearching"@#@ @source: @#@"Loading..."@#@
// @key: @#@"noContacts"@#@ @source: @#@"No records found."@#@
